import { defineMessages, injectIntl } from "react-intl"
import { UNIT_GROUP_TYPES } from "../../state/pricing/UnitGroupTypes"
import { Intl } from "../../state/helpers/IntlProps"
import DurationHelper from "../date/DurationHelper"

const messages = defineMessages({
    "grouped_quantity_unit": {
        id: "templates.sections.form.edit.content.pricing_table.grouped_quantity_unit",
        defaultMessage: "Total number of units",
    },
    "grouped_quantity_time": {
        id: "templates.sections.form.edit.content.pricing_table.grouped_quantity_time",
        defaultMessage: "Total time",
    },
})

class TotalQuantityHelper {
    static getLabelByUnitGroupType(intl: Intl, unitGroupType: UNIT_GROUP_TYPES): string {
        const labelMessage = messages[`grouped_quantity_${unitGroupType}`]
        if (!labelMessage) {
            return ""
        }
        return intl.formatMessage(labelMessage)
    }

    static getTotalQuantityLabelAndAmount(intl: Intl, quantityToDisplay) {
        const unitGroupType = quantityToDisplay.attributes.groupedQuantityType
        const unitGroupTypeLabel = this.getLabelByUnitGroupType(intl, unitGroupType)

        switch (unitGroupType) {
        case UNIT_GROUP_TYPES.UNIT:
            return [
                unitGroupTypeLabel,
                quantityToDisplay.attributes.amount
            ]
        case UNIT_GROUP_TYPES.TIME:
            return [
                unitGroupTypeLabel,
                DurationHelper.calculateDuration(intl, null, quantityToDisplay.attributes.amount)
            ]
        default:
            return ["", ""]
        }
    }
}


export default injectIntl(TotalQuantityHelper)


// WEBPACK FOOTER //
// ./src/common/pricing/TotalQuantityHelper.tsx